import {
    RESET_STATE,
    FETCH_RATES,
    FETCH_RATES_START,
    FETCH_RATES_SUCCESS,
    FETCH_RATES_ERROR,
    FETCH_RATES_CANCEL,
    UPDATE_RATE,
    UPDATE_RATE_START,
    UPDATE_RATE_SUCCESS,
    UPDATE_RATE_ERROR,
    RESET_UPDATE_STATE,
    REMOVE_UPDATE_ERROR,
} from './constants';

/* RATES FETCHING */
const fetchRates = (propertyId, start, end, includeMissing = false) => ({
    type: FETCH_RATES,
    params: { propertyId, start, end, includeMissing },
});

const fetchRatesStarted = (params) => ({
    type: FETCH_RATES_START,
    params,
});

const fetchRatesSucceeded = (data) => ({
    type: FETCH_RATES_SUCCESS,
    data,
});

const fetchRatesFailed = (error) => ({
    type: FETCH_RATES_ERROR,
    error,
});

const fetchRatesCancelled = () => ({
    type: FETCH_RATES_CANCEL,
});

/* RATES UPDATING */

/* Used to update the rates, whether manually or through recommendations */
const updateRate = (propertyId, inventory) => ({
    type: UPDATE_RATE,
    params: { propertyId, type: 'update', inventory },
});

/* For retryable failed updates */
const retryErredRate = (propertyId, date) => ({
    type: UPDATE_RATE,
    params: { propertyId, date, type: 'retry' },
});

/* For failed updates */
const cancelRate = (propertyId, date) => ({
    type: UPDATE_RATE,
    params: { propertyId, date, type: 'cancel' },
});

const updateRateStarted = (params) => ({
    type: UPDATE_RATE_START,
    params,
});

const updateRateSucceeded = (data) => ({
    type: UPDATE_RATE_SUCCESS,
    data,
});

const updateRateFailed = (error) => ({
    type: UPDATE_RATE_ERROR,
    error,
});

const removeRateError = () => ({
    type: REMOVE_UPDATE_ERROR,
});

const resetUpdateState = () => ({
    type: RESET_UPDATE_STATE,
});

/* GENERAL */

const resetState = () => ({
    type: RESET_STATE,
});

export {
    fetchRates,
    fetchRatesStarted,
    fetchRatesSucceeded,
    fetchRatesFailed,
    fetchRatesCancelled,
    updateRate,
    retryErredRate,
    cancelRate,
    updateRateStarted,
    updateRateSucceeded,
    updateRateFailed,
    resetUpdateState,
    removeRateError,
    resetState,
};
